import { CommonModule } from "@angular/common";
import { NgModule, Type } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PipesModule } from "@app/_pipes/_pipes.module";
import { CoreDirectivesModule } from "@app/directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@app/directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@app/directives/_layout/_layout.directives.module";
import { VTableModule } from "@app/directives/_layout/v-table/v-table.module";
import { MiscDirectivesModule } from "@app/directives/_misc/_misc.directives.module";
import { ResourceFiltersDirectivesModule } from "@app/directives/_resourceFilters/_resourceFilters.directives.module";
import { VeriDirectivesModule } from "@app/directives/_veri/_veri.directives.module";
import { providerCreator } from "@app/services/_services.module";
import { DriverService } from "@app/services/driver.service";
import { DriverAssignmentService } from "@app/services/driverAssignment.service";
import { GroupService } from "@app/services/group.service.ajs";
import { TranslationService } from "@app/services/translation.service";
import { VehicleService } from "@app/services/vehicle.service";
import { VehicleInputService } from "@app/services/vehicleInput.service";
import { AlertReviewService } from "./_services/alert-review.service";
import { AlertsService } from "./_services/alerts.service";
import { AlertCategoryComponent } from "./components/alert-category/alert-category.component";
import { AlertDetailComponent } from "./components/alert-detail/alert-detail.component";
import { AxleWeightAlertDetailComponent } from "./components/alert-detail/axle-weight-alert-detail/axle-weight-alert-detail.component";
import { AxleWeightAlertDetailService } from "./components/alert-detail/axle-weight-alert-detail/axle-weight-alert-detail.service";
import { GeofenceAlertDetailComponent } from "./components/alert-detail/geofence-alert-detail/geofence-alert-detail.component";
import { GeofenceAlertDetailService } from "./components/alert-detail/geofence-alert-detail/geofence-alert-detail.service";
import { InputAlertDetailComponent } from "./components/alert-detail/input-alert-detail/input-alert-detail.component";
import { InputAlertDetailService } from "./components/alert-detail/input-alert-detail/input-alert-detail.service";
import { PowerLossAlertDetailComponent } from "./components/alert-detail/power-loss-alert-detail/power-loss-alert-detail.component";
import { PowerLossAlertDetailService } from "./components/alert-detail/power-loss-alert-detail/power-loss-alert-detail.service";
import { TemperatureAlertDetailComponent } from "./components/alert-detail/temperature-alert-detail/temperature-alert-detail.component";
import { TollAlertDetailComponent } from "./components/alert-detail/toll-alert-detail/toll-alert-detail.component";
import { TollAlertDetailService } from "./components/alert-detail/toll-alert-detail/toll-alert-detail.service";
import { TyreRecordAlertDetailComponent } from "./components/alert-detail/tyre-record-alert-detail/tyre-record-alert-detail.component";
import { TyreRecordAlertDetailService } from "./components/alert-detail/tyre-record-alert-detail/tyre-record-detail.service";
import { VehicleDiagnosticAlertDetailComponent } from "./components/alert-detail/vehicle-diagnostic-detail/vehicle-diagnostic-alert-detail.component";
import { VehicleDiagnosticAlertDetailService } from "./components/alert-detail/vehicle-diagnostic-detail/vehicle-diagnostic-detail.service";
import { VideoAlertDetailComponent } from "./components/alert-detail/video-alert-detail/video-alert-detail.component";
import { VideoAlertDetailService } from "./components/alert-detail/video-alert-detail/video-alert-detail.service";
import { AlertReviewDialogComponent } from "./components/alert-review-dialog/alert-review-dialog.component";
import { AlertReviewHistoryComponent } from "./components/alert-review-history/alert-review-history.component";
import { ResolutionCodeEditorComponent } from "./components/resolution-code-editor/resolution-code-editor.component";
import { GroupsModule } from "@app/main/components/resourceManagement/groups/groups.module";


const privateComponents: any[] = [
];

const publicComponents: any[] = [
    AlertReviewDialogComponent,
    ResolutionCodeEditorComponent,
    AlertDetailComponent,
    GeofenceAlertDetailComponent,
    TemperatureAlertDetailComponent,
    AxleWeightAlertDetailComponent,
    InputAlertDetailComponent,
    PowerLossAlertDetailComponent,
    TollAlertDetailComponent,
    TyreRecordAlertDetailComponent,
    VehicleDiagnosticAlertDetailComponent,
    VideoAlertDetailComponent,
    AlertCategoryComponent,
    AlertReviewHistoryComponent
];

const declarations: Type<any>[] = [
];

const providers: any[] = [
    providerCreator(AlertReviewService, "alertReviewService"),
    providerCreator(AlertsService, "alertsService"),
    providerCreator(VehicleInputService, 'vehicleInputService'),
    providerCreator(DriverService, 'driverService'),
    providerCreator(DriverAssignmentService, 'driverAssignmentService'),
    providerCreator(GroupService, 'groupService'),
    providerCreator(TranslationService, 'translationService'),
    providerCreator(VehicleService, 'vehicleService'),
    
    providerCreator(AxleWeightAlertDetailService, "axleWeightAlertDetailService"),
    providerCreator(GeofenceAlertDetailService, "geofenceAlertDetailService"),
    providerCreator(InputAlertDetailService, "inputAlertDetailService"),
    providerCreator(PowerLossAlertDetailService, "powerLossAlertDetailService"),
    providerCreator(TollAlertDetailService, "tollAlertDetailService"),
    providerCreator(TyreRecordAlertDetailService, "tyreRecordAlertDetailService"),
    providerCreator(VehicleDiagnosticAlertDetailService, "vehicleDiagnosticAlertDetailService"),
    providerCreator(VideoAlertDetailService, "videoAlertDetailService")
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        VeriDirectivesModule,
        LayoutDirectivesModule,
        FormsDirectivesModule,
        CoreDirectivesModule,
        MiscDirectivesModule,
        PipesModule,
        VTableModule,
        ResourceFiltersDirectivesModule,
        GroupsModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations]
})
export class AlertsModule {

}
